import React from "react";
import ReactDOM from "react-dom/client";
import LoginFormModal from "./components/LoginFormModal";

export default new class LoginFormService {
    private loginFormModal: HTMLDivElement | undefined;

    public init(): void {
        this.initOpenLoginFormButtonsInContainer(document.body);
    }

    public initOpenLoginFormButtonsInContainer(container: Element): void {
        for (const openLoginButton of container.querySelectorAll<HTMLAnchorElement>(".js-open-login-form")) {
            this.initOpenLoginFormButton(openLoginButton);
        }
    }

    private initOpenLoginFormButton(openLoginButton: HTMLAnchorElement): void {
        openLoginButton.addEventListener("click", (event: MouseEvent) => {
            event.preventDefault();

            if (this.loginFormModal !== undefined) {
                return;
            }

            const root = ReactDOM.createRoot(this.createLoginFormModal());

            root.render(<LoginFormModal
                onAfterClose={(): void => {
                    root.unmount();
                    this.removeLoginFormModal();
                }} />);
        });
    }

    private createLoginFormModal(): HTMLDivElement {
        const loginModal = document.createElement("div");

        document.body.appendChild(loginModal);

        return loginModal;
    }

    private removeLoginFormModal(): void {
        if (this.loginFormModal === undefined) {
            return;
        }

        this.loginFormModal.remove();
        this.loginFormModal = undefined;
    }
}();
